'use strict';

var _ = require('lodash');
var NetSpillRateAggregationFactory = function NetSpillRateAggregationFactory(DataAggregationFactory, configurationService, momentService, fcrService) {
  function NetSpillRateAggregationFactory() {
    DataAggregationFactory.call(this, 'rom-analysis-demand-pax-mode', 'net-spill-rates');
  }
  NetSpillRateAggregationFactory.prototype = Object.create(DataAggregationFactory.prototype);
  NetSpillRateAggregationFactory.constructor = NetSpillRateAggregationFactory;
  NetSpillRateAggregationFactory.prototype.canAggregate = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  NetSpillRateAggregationFactory.prototype.aggregate = function (data) {
    var result = [];
    var market = getMarket(_.first(data));
    var fcrTag = getFCRTagForDataRange(data);
    var defaultConfig = configurationService.getClassGroupConfigByMarket(market + '-' + fcrTag);
    var configGroupedByCabin = _.groupBy(defaultConfig, 'cabinCode');
    var configGroupedByClass = _.groupBy(defaultConfig, 'className');

    //fill grouped obj with possible cabin codes
    var grouped = {};
    for (var dataIndex = 0; dataIndex < data.length; dataIndex++) {
      var elem = data[dataIndex];
      var elemCabin = elem.cabin;
      var elemClass = elem["class"];
      var elemFare = elem.fare || 0;
      var elemDemand = elem.demand || 0;
      var actualRate = elem.actSpill - elem.actRecap;
      var optimalRate = elem.maxSpill - elem.maxRecap;
      grouped[elemCabin] = grouped[elemCabin] || {};
      grouped[elemCabin][elemClass] = {
        iterator: _.get(grouped, [elemCabin, elemClass, 'iterator'], 0) + 1,
        avgFare: _.get(grouped, [elemCabin, elemClass, 'avgFare'], 0) + elemFare,
        demand: _.get(grouped, [elemCabin, elemClass, 'demand'], 0) + elemDemand,
        actualRate: _.get(grouped, [elemCabin, elemClass, 'actualRate'], 0) + actualRate,
        optimalRate: _.get(grouped, [elemCabin, elemClass, 'optimalRate'], 0) + optimalRate
      };
    }

    //preparing result array
    var cabinKeys = Object.keys(grouped);
    for (var cabinIndex = 0; cabinIndex < cabinKeys.length; cabinIndex++) {
      var cabin = cabinKeys[cabinIndex];
      var classKeys = Object.keys(grouped[cabin]);
      for (var classIndex = 0; classIndex < classKeys.length; classIndex++) {
        var className = classKeys[classIndex];
        var entry = grouped[cabin][className];
        entry.classKeysLength = classKeys.length;
        entry.cabin = cabin;
        entry.cabinIndex = configGroupedByCabin[cabin][0].cabinIndex;
        entry["class"] = className;
        entry.classIndex = configGroupedByClass[className][0].classIndex;
        entry.avgFare = Math.round(entry.avgFare * 100 / entry.iterator) / 100;
        entry.actualRate = Math.round(entry.actualRate * 100 / entry.demand) / 100;
        entry.optimalRate = Math.round(entry.optimalRate * 100 / entry.demand) / 100;
        entry.demand = Math.round(entry.demand * 100) / 100;

        //tooltip data
        entry.label = 'Cabin ' + entry.cabin + ' (Class ' + entry["class"] + ')';
        entry.stackLabel = entry.label;
        result.push(entry);
      }
    }
    result = _.orderBy(result, ['cabinIndex', 'classIndex'], ['asc', 'asc']);
    addRowspan(result);
    return result;
  };
  function getMarket(firstRow) {
    var origin = _.get(firstRow, ['origin']);
    var destination = _.get(firstRow, ['destination']);
    return origin && destination ? origin + '-' + destination : undefined;
  }
  function addRowspan(result) {
    var prevCabin;
    _.forEach(result, function (item) {
      if (item.cabin !== prevCabin) {
        item.rowspan = item.classKeysLength;
      }
      prevCabin = item.cabin;
    });
  }
  function getFCRTagForDataRange(data) {
    var selectedDays = _.uniq(_.map(data, function (row) {
      return momentService.of(row.departureDate + 'T' + row.departureTime, momentService.FIELD.DEPARTURE_DATE);
    }));
    return fcrService.getFcrTagForMultipleEntities([_.min(selectedDays), _.max(selectedDays)]);
  }
  return NetSpillRateAggregationFactory;
};
NetSpillRateAggregationFactory.$inject = ['AbstractROMServiceAggregationFactory', 'ConfigurationService', 'MomentService', 'FcrService'];
module.exports = NetSpillRateAggregationFactory;